<template>
  <div class="todo-total">
    <div class="todo-total-title">
      <slot />
    </div>
    <div class="todo-total-value">
      <span>{{ value }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      value: String
    }
  }
</script>

<style lang="scss">
  .todo-total {
    background: grey;
    border-radius: 16px;
    padding: 20px;
    margin: 5px 0;
    text-align: left;
    color: white;

    .todo-total-title {
      font-size: 14px;
      line-height: 17px;
      min-height: 50px;
    }

    .todo-total-value {
      font-style: normal;
      font-weight: 500;
      font-size: 30px;
      line-height: 45px;
    }
  }
</style>
